/* eslint-disable react/prop-types */ // TODO: add props
import { Component, Fragment } from 'react';
import PT from 'prop-types';
import IPT from 'react-immutable-proptypes';
import Immutable from 'immutable';
import Annotation from 'react-image-annotation';
import cx from 'classnames';
import { uploadAsset } from 'admin/domains/fileUpload';
import {
  checklistItemPropType,
  checklistImageAnnotationPropType,
} from '../../propTypes';
import Editor from './Editor';
import Highlight from './Highlight';

export class AnnotatedImage extends Component {
  state = {
    annotation: {},
  };

  onChange = (annotation) => {
    this.setState({ annotation });
  };

  onSubmit = (annotation) => {
    const { geometry, data } = annotation;
    this.props.onAnnotationsChange(
      this.props.checklistImageAnnotations.set(
        String(data.checklistItemSerial),
        Immutable.fromJS(geometry)
      )
    );
    this.setState({
      annotation: {},
    });
  };

  activeAnnotationComparator = (a, b) =>
    Number(a.data.checklistItemSerial) === b;

  get annotations() {
    const a = this.props.checklistImageAnnotations
      .map((annotation, checklistItemSerial) => {
        return Immutable.Map({
          geometry: annotation,
          data: {
            id: Math.random(), // needed for keys
            checklistItemSerial: Number(checklistItemSerial),
          },
        });
      })
      .toList()
      .toJS();

    return a;
  }

  render() {
    const {
      imageUrl,
      onImageUrlChange,
      onClearImage,
      checklistItems,
      highlightedItemSerial,
      setHighlightedSerial = () => null,
      readOnly,
      className,
    } = this.props;

    return (
      <div className={cx(className)}>
        <Annotation
          disableOverlay
          disableAnnotation={readOnly}
          src={imageUrl}
          annotations={this.annotations}
          value={this.state.annotation}
          onChange={this.onChange}
          onSubmit={this.onSubmit}
          activeAnnotationComparator={this.activeAnnotationComparator}
          renderEditor={({ annotation, onChange, onSubmit }) => (
            <Editor
              annotation={annotation}
              onChange={onChange}
              onSubmit={onSubmit}
              checklistItems={checklistItems}
            />
          )}
          renderHighlight={({ key, annotation, active: hovered }) => (
            <Highlight
              key={key}
              annotation={annotation}
              hovered={hovered}
              onActivate={() =>
                setHighlightedSerial(annotation.data.checklistItemSerial, true)
              }
              onDeactivate={() =>
                setHighlightedSerial(annotation.data.checklistItemSerial, false)
              }
              active={
                highlightedItemSerial == annotation.data.checklistItemSerial
              }
            />
          )}
          renderSelector={({ annotation }) => (
            <Highlight annotation={annotation} />
          )}
          renderContent={() => null}
        />
        {!readOnly ? (
          <Fragment>
            <input
              type="file"
              onChange={(e) => {
                const file = e.target.files[0];
                const prefix = 'media/assets/exam_question/';
                uploadAsset(file, prefix).then(
                  (result) => {
                    onImageUrlChange(result.url);
                  },
                  (error) => {
                    throw new Error(error);
                  }
                );
              }}
            />
            <button
              onClick={() => {
                this.onChange({}); // reset the annotation box drawer
                onClearImage();
              }}
            >
              Clear
            </button>
          </Fragment>
        ) : null}
      </div>
    );
  }
}

AnnotatedImage.propTypes = {
  imageUrl: PT.string,
  checklistImageAnnotations: IPT.mapOf(
    checklistImageAnnotationPropType,
    PT.string
  ),
  className: PT.string,
  readOnly: PT.bool,

  // edit mode
  onImageUrlChange: PT.func,
  onAnnotationsChange: PT.func,
  checklistItems: IPT.listOf(checklistItemPropType),

  highlightedItemSerial: PT.number,
  setHighlightedSerial: PT.func,
};

AnnotatedImage.checklistImageAnnotationPropType =
  checklistImageAnnotationPropType;
AnnotatedImage.checklistItemPropType = checklistItemPropType;

export default AnnotatedImage;
